module.exports = __webpack_public_path__ + "assets/anmeldung.44d901a8.pdf";